import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

export default {
    /**
     * Provide lodash get function to the view components.
     */
    install(Vue) {
        Vue.prototype.$get = function(...args) {
            if (args.length && isPlainObject(args[0])) {
                return get(args[0], ...args.slice(1));
            }
            return get(this, ...args);
        };
    },
};
